export function emblaListingSchemaEnhancer(schema, formData = {}, intl) {
  const useListing = !!formData?.useListing;
  const fields = schema?.fieldsets?.[0]?.fields || [];

  // Ensure base fields exist (especially our new ones)
  const baseMustHave = [
    'title',
    'slides',
    'slidesToShow',
    'minSlidesOnMobile',
    'displayMode',
    'autoplay',
    'autoplayDelay',
    'alignment',
    'isFullWidth',
    'loop',
    'hideArrows',
    'hideDots',
    'hideButtons',
    'clickableSlides',
    'hideDescription',
    'showEffectiveDate',
    'equalHeight',
    'backgroundColor',
    'textTone',
  ];

  baseMustHave.forEach((f) => {
    if (!fields.includes(f)) fields.push(f);
  });

  // Always expose the toggle
  if (!fields.includes('useListing')) fields.push('useListing');

  // Ensure properties exist for the new items if missing
  schema.properties = schema.properties || {};
  if (!schema.properties.useListing) {
    schema.properties.useListing = {
      title: 'Use listing source',
      type: 'boolean',
      default: false,
    };
  }

  // Listing-specific fields
  const listingFields = ['query', 'appendManualSlides', 'listingButtonText'];
  if (useListing) {
    listingFields.forEach((f) => {
      if (!fields.includes(f)) fields.push(f);
    });

    // Properties for listing fields
    schema.properties.query = schema.properties.query || {
      title: 'Listing query',
      widget: 'query',
    };
    schema.properties.appendManualSlides = schema.properties.appendManualSlides || {
      title: 'Append manual slides after results',
      type: 'boolean',
      default: false,
    };
    schema.properties.listingButtonText = schema.properties.listingButtonText || {
      title: 'Button text for listing items',
      type: 'string',
      default: 'Read more',
    };
  } else {
    // Remove listing-only fields when not in use
    schema.fieldsets[0].fields = fields.filter((f) => !listingFields.includes(f));
    // Make sure manual slides are present
    if (!schema.fieldsets[0].fields.includes('slides')) {
      schema.fieldsets[0].fields.unshift('slides');
    }
  }

  return schema;
}
